module.exports = __webpack_public_path__ + "static/media/hipercard-logo.2097d64a.png";